import VSelectCourseStyle from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCourseStyle', VSelectCourseStyle),
};
